type BrandLogoProps={
 variant?:'wordmark'|'mark';
 tone?:'green'|'black'|'inverse';
 className?:string;
 decorative?:boolean;
};

/** The accepted outlined Little Can artwork; green is the default. */
export default function BrandLogo({variant='wordmark',tone='green',className='',decorative=false}:BrandLogoProps){
 return <img className={`brand-art brand-${variant} ${className}`.trim()} src={`/brand/graffiti-${variant}-${tone}.svg`} width={variant==='mark'?324:968} height={337} alt={decorative?'':'Graffiti'} draggable={false}/>;
}
